import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const containerStyles: BoxStyleProps = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "64px",
    flexShrink: 0,
    backgroundColor: "colorBackgroundPrimaryStronger",
    paddingTop: "space0",
    paddingBottom: "space0",
    paddingLeft: "space60",
    paddingRight: "space60"
};

export const titleStyles: TextStyleProps = {
    color: "colorTextWeakest",
    fontSize: "fontSize60",
    fontWeight: "fontWeightSemibold"
};

export const minimizeButtonStyles: BoxStyleProps = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    backgroundColor: "transparent",
    color: "colorTextWeakest",
    cursor: "pointer",
    padding: "space20",
    margin: "space0",
    borderRadius: "borderRadius20",
    outline: "0px",
    _hover: {
        backgroundColor: "colorBackgroundPrimary"
    },
    _focusVisible: {
        boxShadow: "shadowFocus"
    }
};
